// # Admin Dashboard Routes
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute';

// # Import blog components
import AdminPosts from '../../general/blog/articles/articles_mn';
import QA from '../../general/blog/qa';
import Discussions from '../../general/blog/discussions';

// # Import library pages
import LibraryStep1 from '../../general/library/step1/library_step_1';
import LibraryStep2 from '../../general/library/step2/library_step_2';

// # Import personal tools
import MyBookmarks from '../../general/bookmarks/my_bookmarks';
import MyNotes from '../../general/notes/my_notes';
import MyFlashcards from '../../general/flashcards/my_flashcards';
import Settings from '../../general/gen_pages/settings';
import Labs from '../../general/extra_content/labs/labs';

// # Import notes and flashcards components
import ChapterNotes from '../../general/notes/chapter_notes';
import ChapterFlashcards from '../../general/flashcards/chapter_flashcards';
import NotePage from '../../general/notes/notepage';

// # Import bookmark components
import BookmarkPage from '../../general/bookmarks/bookmark_page';
import BookmarkCalendar from '../../general/bookmarks/bookmark_calendar';

// # Import community components
import TakeNotes from '../../general/extra_content/take_notes';
import Guide from '../../general/extra_content/guide/guide';
import AnkiGuide from '../../general/extra_content/guide/guide_anki';
import ExamDayGuide from '../../general/extra_content/guide/guide_exam_day';
import Experiences from '../../general/extra_content/experiences/experiences';
import TakeBreak from '../../general/extra_content/take_break/take_break';
import Events from '../../general/extra_content/events/events';
import Roadmaps from '../../general/extra_content/roadmaps/roadmaps';
import Updates from '../../general/extra_content/updates/updates';
import Rotations from '../../general/extra_content/rotations/rotations';

// # Import extras components
import Gallery from '../../general/extra_content/gallery/gallery';
import Clinical from '../../general/extra_content/clinical/clinical';
import Research from '../../general/extra_content/research/research';
import OET from '../../general/extra_content/oet/oet';

// # Import review component
import Reviews from '../../landing/pages/review';
import UserReview from '../../systems/reviews/user_review';

import QuranPage from '../../general/extra_content/take_break/QuranPage';
import Profile from '../../general/profile/profile';

// # Import notifications component
import AdminNotificationsPage from '../../systems/notifications/components/adm_notif_page';

// # Import flashcard components
import FlashcardHome from '../../general/flashcards/tabs/flashcard_home';
import FlashcardBrowser from '../../general/flashcards/tabs/flashcard_browser';
import FlashcardPreferences from '../../general/flashcards/tabs/flashcard_preferences';

const AdminDashRoutes = () => {
  return (
    <Routes>
      {/* # Notifications Route */}
      <Route path="/notifications" element={
        <ProtectedRoute adminOnly={true}>
          <AdminNotificationsPage />
        </ProtectedRoute>
      } />

      {/* # Blog System Routes */}
      <Route path="/blog/articles" element={
        <ProtectedRoute adminOnly={true}>
          <AdminPosts />
        </ProtectedRoute>
      } />
      <Route path="/blog/articles/:articleId" element={
        <ProtectedRoute adminOnly={true}>
          <AdminPosts />
        </ProtectedRoute>
      } />
      <Route path="/blog/qa" element={
        <ProtectedRoute adminOnly={true}>
          <QA />
        </ProtectedRoute>
      } />
      <Route path="/blog/qa/:questionId" element={
        <ProtectedRoute adminOnly={true}>
          <QA />
        </ProtectedRoute>
      } />
      <Route path="/blog/discussions" element={
        <ProtectedRoute adminOnly={true}>
          <Discussions />
        </ProtectedRoute>
      } />
      <Route path="/blog/discussions/:discussionId" element={
        <ProtectedRoute adminOnly={true}>
          <Discussions />
        </ProtectedRoute>
      } />

      {/* # Community Routes */}
      <Route path="/community/notes" element={
        <ProtectedRoute adminOnly={true}>
          <TakeNotes />
        </ProtectedRoute>
      } />
      <Route path="/community/notes/:category" element={
        <ProtectedRoute adminOnly={true}>
          <TakeNotes />
        </ProtectedRoute>
      } />
      <Route path="/community/notes/:category/:noteId" element={
        <ProtectedRoute adminOnly={true}>
          <TakeNotes />
        </ProtectedRoute>
      } />

      {/* # Add Events Route */}
      <Route path="/community/events" element={
        <ProtectedRoute adminOnly={true}>
          <Events />
        </ProtectedRoute>
      } />

      {/* # Guide Routes */}
      <Route path="/community/guide" element={
        <ProtectedRoute adminOnly={true}>
          <Guide />
        </ProtectedRoute>
      } />
      <Route path="/community/guide/anki" element={
        <ProtectedRoute adminOnly={true}>
          <AnkiGuide />
        </ProtectedRoute>
      } />
      <Route path="/community/guide/exam-day" element={
        <ProtectedRoute adminOnly={true}>
          <ExamDayGuide />
        </ProtectedRoute>
      } />
      <Route path="/community/guide/:section" element={
        <ProtectedRoute adminOnly={true}>
          <Guide />
        </ProtectedRoute>
      } />

      <Route path="/community/break" element={
        <ProtectedRoute adminOnly={true}>
          <TakeBreak />
        </ProtectedRoute>
      } />
      <Route path="/community/break/quran" element={
        <ProtectedRoute adminOnly={true}>
          <QuranPage />
        </ProtectedRoute>
      } />
      <Route path="/community/break/:category" element={
        <ProtectedRoute adminOnly={true}>
          <TakeBreak />
        </ProtectedRoute>
      } />
      <Route path="/community/break/:category/:contentId" element={
        <ProtectedRoute adminOnly={true}>
          <TakeBreak />
        </ProtectedRoute>
      } />

      <Route path="/community/roadmaps" element={
        <ProtectedRoute adminOnly={true}>
          <Roadmaps />
        </ProtectedRoute>
      } />
      <Route path="/community/roadmaps/:stepId" element={
        <ProtectedRoute adminOnly={true}>
          <Roadmaps />
        </ProtectedRoute>
      } />
      <Route path="/community/roadmaps/:stepId/:section" element={
        <ProtectedRoute adminOnly={true}>
          <Roadmaps />
        </ProtectedRoute>
      } />

      <Route path="/community/updates" element={
        <ProtectedRoute adminOnly={true}>
          <Updates />
        </ProtectedRoute>
      } />
      <Route path="/community/updates/:category" element={
        <ProtectedRoute adminOnly={true}>
          <Updates />
        </ProtectedRoute>
      } />
      <Route path="/community/updates/:category/:updateId" element={
        <ProtectedRoute adminOnly={true}>
          <Updates />
        </ProtectedRoute>
      } />

      {/* Experiences Route */}
      <Route path="/community/experiences" element={
        <ProtectedRoute adminOnly={true}>
          <Experiences />
        </ProtectedRoute>
      } />

      {/* # Extras Routes */}
      <Route path="/extras/gallery" element={
        <ProtectedRoute adminOnly={true}>
          <Gallery />
        </ProtectedRoute>
      } />
      <Route path="/extras/clinical" element={
        <ProtectedRoute adminOnly={true}>
          <Clinical />
        </ProtectedRoute>
      } />
      <Route path="/extras/research" element={
        <ProtectedRoute adminOnly={true}>
          <Research />
        </ProtectedRoute>
      } />
      <Route path="/extras/oet" element={
        <ProtectedRoute adminOnly={true}>
          <OET />
        </ProtectedRoute>
      } />

      {/* # Library Routes */}
      <Route path="/step1-library" element={
        <ProtectedRoute adminOnly={true}>
          <LibraryStep1 />
        </ProtectedRoute>
      } />
      <Route path="/step2-library" element={
        <ProtectedRoute adminOnly={true}>
          <LibraryStep2 />
        </ProtectedRoute>
      } />

      {/* # Review Routes */}
      <Route path="/reviews" element={
        <ProtectedRoute adminOnly={true}>
          <Reviews />
        </ProtectedRoute>
      } />
      <Route path="/write-review" element={
        <ProtectedRoute adminOnly={true}>
          <UserReview />
        </ProtectedRoute>
      } />

      {/* # Notes System Routes */}
      <Route path="/notes" element={
        <ProtectedRoute adminOnly={true}>
          <MyNotes />
        </ProtectedRoute>
      } />
      <Route path="/notes/general" element={
        <ProtectedRoute adminOnly={true}>
          <MyNotes type="general" />
        </ProtectedRoute>
      } />
      <Route path="/notes/:stepId/:chapterId" element={
        <ProtectedRoute adminOnly={true}>
          <ChapterNotes />
        </ProtectedRoute>
      } />
      <Route path="/notes/:stepId/:chapterId/create" element={
        <ProtectedRoute adminOnly={true}>
          <NotePage />
        </ProtectedRoute>
      } />
      <Route path="/notes/:stepId/:chapterId/edit/:noteId" element={
        <ProtectedRoute adminOnly={true}>
          <NotePage />
        </ProtectedRoute>
      } />

      {/* # Flashcard System Routes */}
      <Route path="/flashcards/*" element={
        <ProtectedRoute adminOnly={true}>
          <MyFlashcards />
        </ProtectedRoute>
      } />
      <Route path="/flashcards/:stepId/:chapterId" element={
        <ProtectedRoute adminOnly={true}>
          <ChapterFlashcards />
        </ProtectedRoute>
      } />
      <Route path="/flashcards/general" element={
        <ProtectedRoute adminOnly={true}>
          <MyFlashcards type="general" />
        </ProtectedRoute>
      } />

      {/* # Bookmark System Routes */}
      <Route path="/bookmarks" element={
        <ProtectedRoute adminOnly={true}>
          <MyBookmarks isAdmin={true} />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/calendar" element={
        <ProtectedRoute adminOnly={true}>
          <BookmarkCalendar isAdmin={true} />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/general" element={
        <ProtectedRoute adminOnly={true}>
          <BookmarkPage type="general" isAdmin={true} />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/step1" element={
        <ProtectedRoute adminOnly={true}>
          <BookmarkPage type="step1" isAdmin={true} />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/step1/:chapterId" element={
        <ProtectedRoute adminOnly={true}>
          <BookmarkPage type="step1" isAdmin={true} />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/step2" element={
        <ProtectedRoute adminOnly={true}>
          <BookmarkPage type="step2" isAdmin={true} />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/step2/:chapterId" element={
        <ProtectedRoute adminOnly={true}>
          <BookmarkPage type="step2" isAdmin={true} />
        </ProtectedRoute>
      } />

      {/* # Personal Tools Routes */}
      <Route path="/settings" element={
        <ProtectedRoute adminOnly={true}>
          <Settings />
        </ProtectedRoute>
      } />
      <Route path="/labs" element={
        <ProtectedRoute adminOnly={true}>
          <Labs />
        </ProtectedRoute>
      } />

      <Route path="/community/rotations" element={
        <ProtectedRoute adminOnly={true}>
          <Rotations />
        </ProtectedRoute>
      } />

      {/* Add Profile Route */}
      <Route path="/profile" element={
        <ProtectedRoute adminOnly={true}>
          <Profile />
        </ProtectedRoute>
      } />
    </Routes>
  );
};

export default AdminDashRoutes;
